import React from "react";
import { useNavigate } from "react-router";
import { ArrowForward, CloudUploadOutlined } from "@material-ui/icons";

const SECTION_ICONS = {
  upload: CloudUploadOutlined,
};

const AIAreaCard = ({ section }) => {
  const navigate = useNavigate();
  const Icon = SECTION_ICONS[section.icon] || CloudUploadOutlined;

  const handleOpen = () => {
    navigate(`/dashboard/ai-area/${section.slug}`);
  };

  return (
    <div
      className="ai-area-card"
      onClick={handleOpen}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleOpen();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="ai-area-card-icon-wrap">
        <Icon className="ai-area-card-icon" />
      </div>

      <h3 className="ai-area-card-title">{section.title}</h3>
      <p className="ai-area-card-desc">{section.description}</p>

      <button type="button" className="ai-area-card-btn">
        {section.actionLabel}
        <ArrowForward className="ai-area-card-btn-icon" />
      </button>
    </div>
  );
};

export default AIAreaCard;
